// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"597":"d8d66ec5","978":"d8d66ec5"}[chunkId] + ".chunk.css";
};